export default __webpack_public_path__ + "static/media/ca_ad_banner.0ec92bd5.jpg";